import { Button, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { VerticalDivider } from '@hero/atoms';
import { TableProducts } from '@hero/components/organisms';
import { OrderStatusBadge, Table } from '@hero/molecules';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetContact } from '@hero/services/contact-service/hooks';
import { useGetOrders } from '@hero/services/order-service/hook';

import * as S from './style';

function ContactDetailRecognitions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: contactData } = useGetContact({ id });

  const [globalFilters, setGlobalFilters] = useState({});
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const { data: recognitionRecipients, isLoading: isRecognitionRecipientsLoading } = useGetOrders(
    {
      filters: {
        type: 'recognition',
        email: contactData?.email
      },
      options: {
        populate: true
      },
      pagination: {
        page: pageIndex + 1,
        limit: pageSize
      }
    },
    { enabled: !!contactData?.id }
  );

  const renderProducts = ({ getValue }) => {
    const value = getValue();

    if (!value.sku) {
      return <S.EmptyLine />;
    }

    return <TableProducts products={[value]} />;
  };

  const columns = [
    {
      header: t('name'),
      cell: ({ row }) => (
        <Button
          variant="link"
          color="neutral"
          onClick={() => navigate(ROUTE_PATHS.MY_RECOGNITION_DETAIL(row.original.recognitionCode))}
        >
          {row.original.recognition?.name}
        </Button>
      )
    },
    {
      header: t('recipientDetails'),
      cell: ({ row }) => (
        <Button
          variant="link"
          color="neutral"
          onClick={() =>
            navigate(
              ROUTE_PATHS.RECOGNITION_RECIPIENT_DETAIL(
                row.original.recognitionCode,
                row.original.code
              )
            )
          }
        >
          {t('seeRecipientGiftStatus', { recipientName: row.original.recipient.firstName })}
        </Button>
      )
    },
    { Header: t('gift'), accessorKey: 'selectedSku', cell: renderProducts },
    {
      header: t('status'),
      cell: ({ row }) => <OrderStatusBadge status={row.original.giftStatus} />
    }
  ];

  return (
    <S.Recognitions>
      <S.ContactDetailHeader>
        <Typography as="div" variant="body2Bold">
          {t('recentRecognitionSendTo', {
            firstName: contactData?.firstName
          })}
        </Typography>
        <VerticalDivider $margin="0 8px" $height="20px" />
        <Typography variant="body2">
          <Trans
            i18nKey="total"
            values={{
              count: recognitionRecipients?.totalDocs
            }}
            components={{
              b: <b />
            }}
          />
        </Typography>
      </S.ContactDetailHeader>
      <Table
        columns={columns || []}
        data={recognitionRecipients?.docs || []}
        loading={isRecognitionRecipientsLoading}
        globalFilters={globalFilters}
        setGlobalFilters={setGlobalFilters}
        pageCount={recognitionRecipients?.totalPages}
        pagination={{
          pageIndex,
          pageSize,
          total: recognitionRecipients?.totalDocs
        }}
        paginationProps={{
          perPageSelection: true
        }}
        setPagination={setPagination}
        manualPagination
        enabled={{ filter: false, search: false, header: true }}
      />
    </S.Recognitions>
  );
}

export { ContactDetailRecognitions };
